// Console-only debug overlay for the hair env probe. Builds a 3D group
// containing the env-splat AABB (white wireframe), the probe origin (red
// sphere), the env centroid (yellow small sphere), and the hair centroid
// (green small sphere). Useful for diagnosing why the probe captures a
// partial env.

import * as THREE from 'three';

export function buildEnvDebugGroup({ envMin, envMax, envCentroid, splatCentroid }) {
  const group = new THREE.Group();
  group.name = 'hair-env-debug';

  // Bounding box of env splats.
  const bboxSize = new THREE.Vector3().subVectors(envMax, envMin);
  const bboxCenter = new THREE.Vector3().addVectors(envMin, envMax).multiplyScalar(0.5);
  const bboxGeom = new THREE.BoxGeometry(bboxSize.x, bboxSize.y, bboxSize.z);
  const bboxEdges = new THREE.EdgesGeometry(bboxGeom);
  const bboxLine = new THREE.LineSegments(bboxEdges,
    new THREE.LineBasicMaterial({ color: 0xffffff }));
  bboxLine.position.copy(bboxCenter);
  bboxGeom.dispose();
  group.add(bboxLine);

  // Probe origin (red).
  const probe = new THREE.Mesh(
    new THREE.SphereGeometry(8, 16, 16),
    new THREE.MeshBasicMaterial({ color: 0xff3333 }));
  probe.position.copy(envCentroid);
  group.add(probe);

  // Env centroid (yellow, same place as probe but smaller so we can see both).
  const envC = new THREE.Mesh(
    new THREE.SphereGeometry(3, 12, 12),
    new THREE.MeshBasicMaterial({ color: 0xffff00 }));
  envC.position.copy(envCentroid);
  group.add(envC);

  // Hair centroid (green).
  const hairC = new THREE.Mesh(
    new THREE.SphereGeometry(5, 12, 12),
    new THREE.MeshBasicMaterial({ color: 0x33ff66 }));
  hairC.position.copy(splatCentroid);
  group.add(hairC);

  return group;
}

export function disposeEnvDebugGroup(group) {
  group.traverse((c) => {
    try { c.geometry?.dispose?.(); } catch {}
    try { c.material?.dispose?.(); } catch {}
  });
}
